__turbopack_context__.v({
  "className": "montserrat_350df577-module__sveg3W__className",
});
